<template>
  <a-tooltip
    placement="top"
  >
    <template v-if="text === '计费异常' && desc"     slot="title">
      <p>
        {{ desc }}
      </p>
    </template>
    <span :class="type + ' statusTag'">{{ text }}</span>
  </a-tooltip>
</template>

<script>
// type 类型 sccuss err over carry

export default {
  name: 'StatusTag',
  props: {
    type: {
      type: String,
      default: '',
    },
    desc: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.statusTag {
  display: inline-block;
  text-align: left;
  height: 24px;
  line-height: 24px;
  font-size: 14px;
  font-weight: 400;
  color: #171717;
  // font-weight: bold;
}
.sccuss {
  color: #606266;
}
.err {
  color: #f56c6c;
}
// .over{
//   color: #606266;;
// }
.carry {
  color: #f56c6c;
}
</style>
